module.exports = function ($interval, $rootScope, Restangular, shopperService, config, $window) {
    let api, contextExpiryInterval;

    function checkVersionInfo(response) {
        if (response.VersionInfo !== config.CurrentVersion) {
            $window.location.reload();
        }
    }

    /**
     * This function get the current server side version and check if context is valid. If the api call
     * returns a 200 ok then the context is considered valid. Otherwise if the api call returns a 401 then
     * the application will deal with that globally as a side effect.
     */
    function checkContextIsValid() {
        if (!shopperService.IsGuest) {
            api.one('context').get().then(checkVersionInfo);
        } else {
            api.one('guest').get().then(checkVersionInfo);
        }
    }

    function startWaitingForContextExpiry() {
        if (contextExpiryInterval) {
            $interval.cancel(contextExpiryInterval);
        }

        contextExpiryInterval = $interval(checkContextIsValid, config.ContextExpiryPeriod + 60000);
    }

    function HeartbeatService() {
        api = Restangular.one('heartbeat');
    }

    /**
     * Start the heartbeat which periodically checks that the context has not expired. Should be called at
     * application startup. Will only listen for valid contexts once the user has logged in.
     */
    HeartbeatService.prototype.startContextHeartbeat = function () {
        startWaitingForContextExpiry();
    };

    HeartbeatService.prototype.checkContextIsValid = checkContextIsValid;

    return new HeartbeatService();
};



// WEBPACK FOOTER //
// ./src/common/heartbeat/heartbeat.service.js